module.exports = __webpack_public_path__ + "static/media/Image.e623a484.png";